// mospina 10-10-16 EPT-2100 Versionamiento AVATAR
import { Component, OnInit, AfterViewInit, ViewChild, ViewEncapsulation, inject } from '@angular/core';
import { SharedService } from 'src/app/core/services/shared.service';
import { ChatUIComponent, MessageModel, UserModel } from '@syncfusion/ej2-angular-interactive-chat';
import { HttpClient } from '@angular/common/http';
// mospina 10-10-16 EPT-2100 Versionamiento AVATAR
import { VersionService } from 'src/app/core/services/version.service';
import { VERSION_FRONT } from 'src/app/core/config/config';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FooterComponent implements OnInit, AfterViewInit {

  year: number = new Date().getFullYear();
  urlValidarPermiso = "api/ws/msa/S02ARC_WS/validarDerecho";
  webhookIA = 'https://chatbot.avatarsys.io/webhook/ae1ce3a9-9fe4-486c-960d-6cd59505a519';

  chatAbierto = false;
  acceso = false;

  @ViewChild('chatUI') public chatUI: ChatUIComponent;

  public botUser: UserModel = {
    id: 'avatarsys-bot',
    user: 'AVATARSYS',
    avatarUrl: 'assets/images/avatar-ia-v1.png'
  };

  public currentUser: UserModel = {
    id: 'user-01',
    user: 'Usuario'
  };

  public messages: MessageModel[] = [
    {
      author: this.botUser,
      text: '¡Hola! Soy tu asistente de AVATARSYS. ¿En qué te ayudo?'
    }
  ];

  public suggestions: string[] = ['Saldos', 'Deudas', 'Tutoriales'];

  // mospina 10-10-16 EPT-2100 Versionamiento AVATAR
  versionFront = VERSION_FRONT;
  versionBack$ = inject(VersionService).back$;

  constructor(private dataService: SharedService, private http: HttpClient) {}

  ngOnInit() {
    this.dataService.ConsultarWS(this.urlValidarPermiso, JSON.stringify({ S03COD: 'MSA-HABILITAR-CHAT' })).subscribe(datos => {
      if (datos.acceso == true) {
        this.acceso = true;
        const script = document.createElement("script");
        script.src = 'https://aktek.bolddesk.com/chatwidget-api/widget/v1/65719eb8-bd00-435f-b8d2-f4c8d6aea1fc';
        document.head.appendChild(script);
        window['boldChatSettings'] = {
          email: localStorage.getItem('loggedUserEmail'),
          maintainIsOpen: false
        };
      }
    });
  }

  ngAfterViewInit() {}

  toggleChat() {
    this.chatAbierto = !this.chatAbierto;
    setTimeout(() => {
      try {
        const input = document.querySelector('.e-chat-input') as HTMLInputElement;
        if (this.chatAbierto && input) { input.focus(); }
      } catch (e) {}
    }, 300);
  }

  onMessageSend(args: any) {
    this.chatUI.suggestions = [];

    this.chatUI.typingUsers = [this.botUser];

    setTimeout(() => {
      const el = document.querySelector('.e-typing-indicator .e-user-text');
      if (el) {
        el.textContent = el.textContent?.replace('is typing', 'está escribiendo') ?? el.textContent;
      }
    }, 50);

    setTimeout(() => {
      const el = document.querySelector('.e-chat-send');
      if (el) {
        el.setAttribute('aria-label', 'Enviar');
        el.setAttribute('title', 'Enviar');
      }
    }, 50);

    const body = {
      message: args.message.text,
      sessionId: localStorage.getItem("X-AVATAR-PAD10COD"),
      spinner: false
    };

    this.http.post(this.webhookIA, body).subscribe({
      next: (resp: any) => {
        this.chatUI.typingUsers = [];

        let textoFinal = 'No obtuve una respuesta clara.';

        if (Array.isArray(resp) && resp.length > 0) {
          textoFinal = resp[0].output;
        } else if (resp && resp.output) {
          textoFinal = resp.output;
        }

        this.chatUI.addMessage({
          author: this.botUser,
          text: textoFinal
        });
      },
      error: (err) => {
        this.chatUI.typingUsers = [];
        this.chatUI.addMessage({
          author: this.botUser,
          text: 'Lo siento, hubo un problema al conectar. Intenta de nuevo más tarde.'
        });
        console.error('Error Webhook:', err);
      }
    });
  }
}